import { default as place } from './place/routes'

export default [
    ...place,
    {
        path: '/ambiences',
        name: 'ambiences',
        component: () => import ('./pages/Index'),
        meta: {
            title: 'Ambientes',
            icon: 'mdi-flask-outline',
            breadcrumbs: [
                { text: 'Ambientes', disabled: true, href: '/' }
            ],
        }
    },
    {
        path: '/ambiences/catalog',
        name: 'ambiences-catalog',
        component: () => import ('./pages/Catalog'),
        meta: {
            title: 'Catálogo de Ambientes',
            icon: 'mdi-view-grid-outline',
            breadcrumbs: [
                { text: 'Ambientes', disabled: false, href: '/ambiences' },
                { text: 'Catálogo', disabled: true, href: '/' }
            ],
        }
    },
]